// extracted by mini-css-extract-plugin
export default {"row":"Row__row___nJZ7f","user":"Row__user___NHohn"};